'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;

    this.newApp = {
      modelGroups: []
    };
  }

  $onInit() {
    this.getCategories();
    this.getList();
  }

  uploadApk(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传APK，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/apks/uploadFile',
      file: file,
      data: this.newApp,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.$state.go('appstore.list');
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  getCategories() {
    this.$http.get('/api/categories/appForWeb').then(res => {
      this.categories = res.data.children;
    })
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.newApp.modelGroups.indexOf(id);
    if (idx > -1) {
      this.newApp.modelGroups.splice(idx, 1);
    } else {
      this.newApp.modelGroups.push(id);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/appstore/add/add.controller.js